<template>
	<div class="pagination" v-if="pages?.length">
		<button class="pagination__button" :disabled="!prev" @click="handlePagination($event, 'prev')">
			<span class="pagination__button-icon"></span>
		</button>
		<ul class="pagination__pages">
			<li
				v-for="(page, index) in pages"
				:class="[page == current ? 'pagination__page pagination__page_current' : 'pagination__page']"
				:key="index"
				@click="handlePagination($event, page)"
			>
				{{ page }}
			</li>
		</ul>
		<button class="pagination__button" :disabled="!next" @click="handlePagination($event, 'next')">
			<span class="pagination__button-icon"></span>
		</button>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";

	export default {
		name: "Pagination",
		data() {
			return {
				start: null,
				limit: null,
				total: null,
				pages: null,
				current: null,
				prev: false,
				next: false,
			};
		},
		computed: {
			...mapGetters({
				pagination: "getCommonPagination",
			}),
		},
		methods: {
			/* INIT FUNCTIONS */
			initPagination() {
				if (this.pagination) {
					this.start = this.pagination.start;
					this.limit = this.pagination.limit;
					this.total = this.pagination.total;
					this.current = this.current || 1;
					this.pages = this.getPaginationModel(this.current, Math.ceil(this.total / this.limit));

					if (this.start + this.limit >= this.total) this.next = false;
					else this.next = true;
				}
			},

			/* SPECIAL FUNCTIONS */
			getPaginationModel(current, total) {
				const delta = 1; // Сколько страниц показывать рядом с текущей
				const range = [];
				const rangeWithDots = [];
				let l;

				// Всегда добавляем первую страницу
				range.push(1);

				for (let i = current - delta; i <= current + delta; i++) {
					if (i > 1 && i < total) {
						range.push(i);
					}
				}

				// Всегда добавляем последнюю страницу
				if (total > 1) {
					range.push(total);
				}

				// Вставляем многоточия там, где есть разрывы в числах
				for (let i of range) {
					if (l) {
						if (i - l === 2) {
							rangeWithDots.push(l + 1);
						} else if (i - l !== 1) {
							rangeWithDots.push("...");
						}
					}
					rangeWithDots.push(i);
					l = i;
				}

				return rangeWithDots;
			},

			/* EVENT HANDLERS */
			handlePagination(event, param) {
				if (param === "...") return;

				let payload = {
					pagination: {
						start: null,
						limit: null,
						total: null,
					},
				};

				if (param === "prev") {
					this.current = this.current - 1;

					this.start = this.start - this.limit;

					if (this.start <= 0) this.start = 0;
					if (this.start === 0) this.prev = false;

					this.next = true;
				}

				if (param === "next") {
					this.current = this.current + 1;

					this.start = this.start + this.limit;

					if (this.start >= this.total) this.start = this.total - this.limit;
					if (this.start === this.total - this.limit) this.next = false;

					this.prev = true;
				}

				if (typeof param === "number") {
					this.current = param;

					this.start = param * this.limit - this.limit;
					this.prev = true;
					this.next = true;

					if (this.start === 0) this.prev = false;
					if (this.start === this.total - this.limit) this.next = false;
				}

				payload.pagination.start = this.start;
				payload.pagination.limit = this.limit;
				payload.pagination.total = this.total;

				//localStorage.setItem("systems__objects-start", this.start);

				this.$emit("pgnchange", event, payload);
			},
		},
		mounted() {
			this.initPagination();
		},
		watch: {
			"pagination.start": function () {
				this.initPagination();
			},
			"pagination.total": function () {
				this.initPagination();
			},
			"pagination.limit": function () {
				this.initPagination();
			},
		},
	};
</script>

<style lang="scss" scoped>
	.pagination {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;

		&__button {
			@include base;

			position: relative;
			height: 36px;
			min-width: 36px;
			padding: 0;
			border: 0;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;

			&:first-child {
				.pagination__button-icon {
					transform: rotate(135deg);
				}
			}

			&:last-child {
				.pagination__button-icon {
					transform: rotate(-45deg);
				}
			}

			&:hover {
				.pagination__button-icon {
					border-color: #bcbcbc;
				}
			}

			&:disabled {
				cursor: auto;
				pointer-events: none;

				.pagination__button-icon {
					border-color: #9b9b9b;
				}
			}

			&-icon {
				width: 7px;
				height: 7px;
				border: solid #000;
				border-width: 0 2px 2px 0;
			}
		}

		&__pages {
			margin: 0;
			padding: 0 10px;
			list-style: none;
			display: flex;
			align-items: center;
		}

		&__page {
			font-size: 14px;
			margin: 0 5px;
			color: #9b9b9b;
			cursor: pointer;

			&:hover {
				color: #474747;
			}

			&_current {
				color: #000;
			}
		}
	}
</style>
